export enum EMedicalFormPrint {
  MedicalRecordForm = 'medical-record-form',
  MedicalOrderForm = 'medical-order-form',
  MedicalPrescriptionForm = 'medical-prescription-form',
  PaymentForm = 'payment-form'
}
